import { CategoryApiFacade } from "../category/category.api-facade";
import { ContactType } from "./contact-type.model";
import { Observable } from "rxjs/Observable";
import { ApiRequestOptions } from "../../../core/services/api/request-options";

export class ContactTypeApiFacade extends CategoryApiFacade<ContactType> {

    get(accountId: string, id: string, options?: ApiRequestOptions): Observable<ContactType> {
        return this.GET(`/accounts/${accountId}/contacttypes/${id}`, options)
            .map(object => new ContactType(object));
    }

    getAll(accountId: string, options?: ApiRequestOptions): Observable<Array<ContactType>> {
        return this.CGET(`/accounts/${accountId}/contacttypes`, options)
            .map(objects => objects.map(object => new ContactType(object)));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/contact-type/contact-type.api-facade.ts